<template>
  <date-time-field :output-format="getFormat($page.props.locale)" :value="value" :settings="settings"></date-time-field>
</template>

<script>
import DateTimeField from '@kanrisha/components/Elements/Display/DateTimeField';

export default {
  components: {
    DateTimeField,
  },
  props: {
    value: { type: String, default: () => '' },
    outputFormat: { type: String, default: () => null },
    settings: { type: Object, default: () => ({ iconClass: true, diffColors: true }) },
  },
  setup(props) {
    const getFormat = (locale) => {
      if (props.outputFormat) {
        return props.outputFormat;
      }

      switch (locale) {
        case 'de':
          return 'DD.MM.YYYY';
        case 'en':
          return 'DD/MM/YYYY';
      }
    };

    return {
      getFormat,
    };
  },
};
</script>
